import axios from 'axios';
import config from '../Config';
import authHeader from './auth-header';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;
const getActivityLogList = (page, pageSize, search, ordering) => {
  return axios.get(`${API_URL}/api/${API_VERSION}/activity-log/`, {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pageSize,
      search: search,
      ordering: ordering,
    },
  });
};

const createActivityLog = activityData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/activity-log/`,
    activityData,
    {
      headers: authHeader(),
    },
  );
};

const dieCategoryService = {
  getActivityLogList,
  createActivityLog,
};

export default dieCategoryService;
